import { inject, observer } from "mobx-react";
import React from "react";
import { FormGroup, Menu, withStyles } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import FileCopy from "@material-ui/icons/FileCopy";
import PlayArrow from "@material-ui/icons/PlayArrow";
import SaveAlt from "@material-ui/icons/SaveAlt";
import dayjs from "dayjs";
import EditIcon from "@material-ui/icons/Edit";
import { download } from "../utils/downloadUtil";
import { AddToQueue } from "@material-ui/icons";
import TrashCan from "mdi-material-ui/TrashCan";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Button from "@material-ui/core/Button";

const MenuButton = withStyles({
  root: {
    justifyContent: "left",
    width: "100%"
  }
})(Button);

class CustomClipActions extends React.Component {
  state = {
    anchorEl: null,
    loading: false
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const {
      item,
      videoPlayerStore,
      authStore,
      reelStore,
      customClipActionsStore
    } = this.props;

    const { anchorEl } = this.state;

    return (
      <React.Fragment>
        <IconButton
          aria-label="More"
          aria-owns={anchorEl ? "long-menu" : null}
          aria-haspopup="true"
          onClick={this.handleClick}
          style={{ padding: "6px" }}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <FormGroup style={{ padding: "6px" }}>
            {item.gamePk !== -1 && (
              <MenuButton
                variant={"text"}
                onClick={() => {
                  customClipActionsStore.editCustomClip(item);
                }}
              >
                <EditIcon style={{ marginRight: "10px" }} /> Edit
              </MenuButton>
            )}

            <MenuButton
              variant={"text"}
              onClick={() => {
                reelStore.addVideo({
                  url: item.url,
                  thumbnailUri: item.thumbnailUri
                });
              }}
            >
              <AddToQueue style={{ marginRight: "10px" }} /> Add To Reel
            </MenuButton>

            <MenuButton
              variant={"text"}
              onClick={() => navigator.clipboard.writeText(item.url)}
            >
              <FileCopy style={{ marginRight: "10px" }} /> Copy Link
            </MenuButton>

            <MenuButton
              variant={"text"}
              onClick={() => {
                videoPlayerStore.showVideoSrc(item.url);
              }}
            >
              <PlayArrow style={{ marginRight: "10px" }} /> Watch
            </MenuButton>

            {authStore.canDownloadVideos && (
              <MenuButton
                variant={"text"}
                onClick={() => {
                  download(item.url, item.description || dayjs().format());
                }}
              >
                <SaveAlt style={{ marginRight: "10px" }} /> Download
              </MenuButton>
            )}

            {customClipActionsStore.canDeleteCustomClip(item) && (
              <MenuButton
                variant={"text"}
                onClick={() => {
                  customClipActionsStore.deleteCustomClip(item);
                }}
              >
                <TrashCan style={{ marginRight: "10px" }} /> Delete
              </MenuButton>
            )}
          </FormGroup>
        </Menu>
      </React.Fragment>
    );
  }
}

export default inject(
  "videoPlayerStore",
  "authStore",
  "reelStore",
  "customClipActionsStore"
)(observer(CustomClipActions));



// WEBPACK FOOTER //
// ./src/components/CustomClipActions.js